import { Tag } from "./tag";
import { Subject } from "rxjs";
export class TagDependencyEntry {
  constructor(
    public sourceType: string,
    public sourceName: string
  ) {
  }
}
export class DeleteTagResponse {
  constructor(
    public success: boolean,
    public dependencies: TagDependencyEntry[] = []
  ) {
  }
}
export class UpdateTagResponse implements DeleteTagResponse {
  constructor(
    public success: boolean,
    public dependencies: TagDependencyEntry[] = []
  ) {
  }
}
export abstract class TagRepository {
  generalTagCreated: Subject<Tag>;

  getGeneralTags: () => Tag[];

  getAssetTypeTags: () => Tag[];

  getDayPartingTags: () => Tag[];

  CreateGeneralTag: (tagName: string) => Promise<Tag>;

  Update: (tag: Tag) => Promise<UpdateTagResponse>;

  Delete: (tag: Tag) => Promise<DeleteTagResponse>;
}
